import React from 'react';
import {observer} from 'mobx-react';
import s from '../../s';
import ATCButton from './atc-button';
import ShareIcon from '../share-icon';
import {Portal} from '../../../util';
import {screenResizeStore} from '../../../global/store/screen-resize-store';
import {isProductDesktopViewport} from '../viewport/viewport';
import {INST_PLATE_ATC_LABEL} from '../engraved-plates/inst-plate/inst-plate-rules';

declare const modalOpen: (id: string) => void;

interface IATCProps {
    lite?: boolean;
}

const ATC: React.FC<IATCProps> = observer(({lite}) => {
    const isDesktopViewport = isProductDesktopViewport(screenResizeStore.width);

    // A personalized plate (INST-PLATES) is approved on the way to the cart: every Add to Cart reads so.
    const label = s.isInstPlate ? INST_PLATE_ATC_LABEL : undefined;

    return (
        <div className="position-relative">
            <div
                aria-live="assertive"
                aria-atomic="true"
                className="sr-only"
            >
                {s.ui.atc_busy ? 'Adding to cart, please wait...' : ''}
            </div>

            <div className="atc-lg">
                <div className="atc-buttons-container">
                    <ATCButton
                        additionalClass={lite ? 'sm' : 'lg'}
                        label={label}
                    />
                </div>

                {!s.IsPortal3 && !lite && s.isRetail && (
                    <div className="return">
                        <button
                            className="link link-btn"
                            onClick={() => modalOpen('modal-return-policy')}
                            type="button"
                            aria-label="View information about return policy"
                            aria-haspopup="dialog"
                            aria-controls="modal-return-policy"
                        >
                            Easy, {Portal && Portal.PortalID < 3 ? '120' : '30'}-day return policy
                        </button>
                    </div>
                )}

                {s.ui.show_atc && (
                    <div className="sticky-atc">
                        <ATCButton
                            additionalClass="sticky"
                            label={label}
                        />
                    </div>
                )}

                {s.ui.show_atc && s.ps.atc_error && s.ps.atc_error !== '' && (
                    <div
                        className="alert alert-danger mt-1"
                        role="alert"
                        aria-live="assertive"
                    >
                        <b>Error</b>
                        <div className="mt-2">{s.ps.atc_error}</div>
                    </div>
                )}
            </div>

            {!s.IsPortal3 && isDesktopViewport && (
                <div style={{position: 'absolute', top: 8, left: 0}}>
                    <ShareIcon />
                </div>
            )}
        </div>
    );
});

export default ATC;
